<template>
    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <FilterPanel v-if="filterDataSource" :dataSource="filterDataSource" v-bind:status.sync="executionStatus" :ignore-colors="true"/>

        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="entities"
            :options.sync="options"
            :server-items-length="total"
            :items-per-page="10"
            :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
            :page.sync="options.page"
            @page-count="paginationPageCount = $event"
            class="elevation-1 customization-list-table pagination-list-table sticky-table"
            @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents.Document', common: data.item.iscommon })"
        >
            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

            <template v-slot:[`item.controldate`]="{ item }">
                <div class="d-flex align-center">
                    {{ getSrokFieldText(item) }}
                    <template v-if="item.prolongationcount > 0">
                        &nbsp;
                        <div class="font-weight-bold" style="color: #1976d2">({{ toRoman(item.prolongationcount) }})</div>
                    </template>
                </div>
            </template>

            <template v-slot:[`item.mainregdate`]="{ item }">
                <div>{{dateFormat(item.mainregdate, 'DD.MM.YYYY')}}</div>
            </template>

            <template v-slot:[`item.authorname`]="{ item }">
                <v-workplace-chip
                    v-if="item.authorname"
                    :id="item.authorid"
                    :name="item.authorname"
                />
            </template>

            <template v-slot:[`item.maintheme`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.maintheme">
                            {{ item.maintheme }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.ordersubject`]="{ item }">
                <div class="elipsis-text-wrap">
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.ordersubject">
                            {{ item.ordersubject }}
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.svod`]="{ item }">
                <v-workplace-chip
                    v-if="item.svod"
                    :id="item.svodworkplaceid"
                    :name="item.svod"
                />
            </template>

            <template v-slot:[`item.controlstatus`]="{ item }">
                <StatusChip :status="getStatus(item)"/>
            </template>

            <template v-slot:[`footer.prepend`]>
                <v-pagination
                    v-model="options.page"
                    :length="paginationPageCount"
                    :total-visible="$listPaginationTotal"
                    color="teal"
                ></v-pagination>
            </template>

        </v-data-table>

    </div>
</template>

<script>
import i18n from '@/i18n';
import { httpAPI } from "@/api/httpAPI";
import _ from 'lodash';
import sys from '@/services/system';
import { mapActions, mapGetters } from 'vuex';
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import StatusChip from '@/components/global/chips/StatusChip';
import FilterPanel from '@/components/documents/FilterPanel.vue';

export default {
    name: "ProtocolsByPastPeriods",
    components: {
        Toolbar,
        SearchPanel,
        StatusChip,
        FilterPanel
    },
    columnIndex: {
        "regnumber" : 5,
        "controldate": 8,
        "authorname" : 10,
        "svod": 11,
        "executiontext": 13,
        "mainregdate": 17,
        "maintheme": 18,
        "ordersubject": 24,
    },
    computed:{
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        headers() {
            let arr =  [
                { text: i18n.t("№_пункта"), value: 'regnumber', width: '150px' },
                { text: i18n.t("Рег._дата"), value: 'mainregdate', width: '110px' },
                { text: i18n.t("Автор_поручения"), value: 'authorname', width: '15%' },
                { text: i18n.t("Протокол"), value: 'maintheme' },
                { text: i18n.t("Поручение"), value: 'ordersubject' },
                { text: i18n.t("Срок_исполнения"), value: 'controldate', width: '220px' },
                { text: i18n.t("Исполнитель"), value: 'svod'},
                { text: i18n.t("Статус"), value: 'controlstatus', width: '150px', sortable: false, class: 'status-col' }
            ]
            return arr;
        },
        search: {
            get: function() {
                return this.$store.getters[`orders/lists/protocolsbypastperiods/getSearch`];
            },
            set: _.debounce(function(v) {
                this.$store.commit(`orders/lists/protocolsbypastperiods/SET_TABLE_OPTION_PAGE`, 1);
                this.$store.commit(`orders/lists/protocolsbypastperiods/SET_SEARCH`, v);
            }, 500)
        },
        executionStatus: {
            get: function() {
                return this.$store.getters[`orders/lists/protocolsbypastperiods/getExecutionStatus`];
            },
            set: function(newValue) {
                this.$store.commit(`orders/lists/protocolsbypastperiods/SET_EXECUTION_STATUS`, newValue);
            }
        },
        options: {
            get: function() {
                return this.$store.getters[`orders/lists/protocolsbypastperiods/getTableOptions`];
            },
            set: function(newValue) {
                this.$store.commit(`orders/lists/protocolsbypastperiods/SET_TABLE_OPTION`, newValue);
            }
        },
        /*fromdate(){
            return this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD');
        },*/
        todate() {
            return this.$moment().startOf('month').format('YYYY-MM-DD');
        },
        filter () {
            return {
                ...this.options,
                //From: this.fromdate,
                To: this.todate,
                ArchYear: -1,
                SearchStr: this.search,
                //ProtocolControlState: this.status != 4 ? this.status : null,//  '1' - В работе '2' - Выполнен '3' - Снят с контроля
                ExecutionStatus: this.executionStatus
            }
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        },
    },
    data: () => {
        return {
            loading: true,
            total: 0,            
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
            filterDataSource: null,
        }
    },
    methods: {
        ...mapActions('orders', ['updateCounter']),
        getStatus(item){
            return this.avaibleStatuses[item.controlstatus] ?? item.controlstatus;
        },
        onToolbarClick(event, btn){
            this[btn.Action](btn);
        },
        async Refresh() {
            await this.getData(true);
        },
        async Export(){
            let filter = {
                To: this.todate,
                ProtocolControlState: '1', 
                ExecutionStatus: 'All',
                ArchYear: -1,
                OrderBy: [this.$options.columnIndex["controldate"], this.$options.columnIndex["regnumber"] ],
                OrderDir: [false, false],
            };
            let exportURI = `api/orders/svetoforexport_v2?param=${JSON.stringify(filter)}&mode=${process.env.NODE_ENV}`;
            exportURI += `&token=${this.$store.getters['global/auth/getUserInfo']?.Token}`;
            
            let text = i18n.t('Экспорт_списка_поручений_до_formatedDateTimeTo.message', { formatedDateTimeTo: this.$moment(this.todate).format('DD.MM.YYYY') });

            this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'Xls' });
        },
        update: _.debounce(function (object) {            
            this.updateSource(object);
        }, 250),
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `api/orders/filter?collection=${this.$store.getters['orders/getCurrentCollection']}`,
                method: 'GET',
            });

            this.filterDataSource = filterResponse ? filterResponse.data.Payload : null;
        },
        async getData(isRefresh = false) {
            this.updateCounter();
            await this.loadFilters();

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
                
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `/api/orders/list?collection=Protocol.Svetofor.V2&filter=${this.getTableFilterObject()}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, ArchYear, ExecutionStatus } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "controldate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn];

            let filter = { ProtocolControlState: '1', ExecutionStatus, ArchYear, SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage };

            return JSON.stringify(filter);
        },
        getSrokFieldText(item) {
            if (item.prolongationcount > 0)
                return `${this.dateFormat(item.firstcontroldate, 'DD.MM.YYYY')} ➜ ${this.dateFormat(item.controldate, 'DD.MM.YYYY')}`
            return this.dateFormat(item.controldate, 'DD.MM.YYYY')
        },
        toRoman: sys.toRoman,
        dateFormat: sys.dateFormat,
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        },
    },
    async created() {
        let menu = [
            {
                "Action": "Export",
                "Icon": "doc_send",
                "Items": null,
                "Text": "Экспорт_списка",
                "ToolTip": "Экспорт_полного_списка_поручений",
                "Type": "Documents",
                Localize: true
            },
            {
                "Action": "Refresh",
                "Icon": "refresh",
                "Items": null,
                "Text": "Обновить",
                "ToolTip": "Обновить_форму",
                "Type": null,
                Localize: true
            }
        ];

        this.$store.commit('documents/toolbar/SET_MENU', { menu });
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    },
}
</script>
